export default __webpack_public_path__ + "static/media/Punto_10_Chiesa_degli_Olandesi_SPA_Def.b8f82a50.aac";